export const applyMiddlewares = (middlewares, args) => {
  return middlewares.reduce((result, middleware) => middleware(result), args);
};